import { useExperienceChat } from '#providers/experiences/experience-chat/use-experience-chat/index.ts';
import { useExperience } from '#providers/experiences/use-experience/index.ts';

export const useCanOpenStep = (): boolean => {
  const { isStepBusy } = useExperience();
  const { hasPendingAnswer } = useExperienceChat();

  return !isStepBusy && !hasPendingAnswer;
};
